/* eslint-disable @typescript-eslint/member-ordering */

import { Component, computed, inject, OnInit, Signal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppConfigModel, ContentConfig, PageModel } from '@libs/cms/models';
import { CmsComponent } from '@libs/cms/components';
import { AuthService } from '@libs/shared/auth';
import { CustomerModel } from '@libs/account/models';
import { AppConfigService, PageMetadataService, PageViewService } from '@libs/shared/services';
import { ContentAnchorScrollService } from '../content/services';

@Component({
  selector: 'ui-home',
  templateUrl: './home.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    CmsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    ContentAnchorScrollService,
  ],
})
export class HomeComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly appConfigService: AppConfigService = inject(AppConfigService);
  private readonly pageMetadataService: PageMetadataService = inject(PageMetadataService);
  private readonly pageViewService: PageViewService = inject(PageViewService);
  private readonly contentAnchorScrollService: ContentAnchorScrollService = inject(ContentAnchorScrollService);

  public readonly customer: Signal<CustomerModel | undefined> = this.authService.currentCustomer;
  public readonly appConfig: Signal<AppConfigModel | undefined> = toSignal(this.appConfigService.getConfig());

  public readonly config: Signal<ContentConfig> = computed(() => ({
    path: '/',
    customerNumber: this.customer()?.id,
  }));

  public ngOnInit(): void {
    this.pageViewService.setPath('/');
  }

  public onPageLoaded(page: PageModel): void {
    this.pageViewService.setAvailableLanguages(page.availableLanguages);
    this.pageMetadataService.update(page, this.appConfig()?.company.title);
  }

  public onLoadResult(hasContent: boolean): void {
    if (hasContent) {
      this.contentAnchorScrollService.scheduleScrollToCurrentAnchor();
    }
  }
}
